import pdfMake from "pdfmake/build/pdfmake";
// receives the height and number of rows. 
// Sets the same fixed height for each row
// Returns the object as expected by pdfmake
export function _emptyTable(height,numberOfRows) {
  let
    tableObj = {
      table: {
        headerRows: 0,
        dontBreakRows: true,
        widths: '*', // divides the page in even parts if the elements in the columns don't specify padding
        heights: [],
        body: []
      },
      layout: {
        paddingLeft: function(i, node) { return 0; },
        paddingRight: function(i, node) { return 0; },
        paddingTop: function(i, node) { return 0; },
        paddingBottom: function(i, node) { return 0; },
        hLineWidth: function (i, node) { return 1; },
        vLineWidth: function (i, node) { return 1; },
      }
    }
  
  if (numberOfRows) {
    for (let i = 0 ; i < numberOfRows; i++) {
      tableObj.table.heights.push(height)
    }
  } else {
    tableObj.table.heights = '*'
  }

  return tableObj
}

// Expected format for pdfmake to receive fonts
const fonts = {
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
}

export function print(docDefinition) {
  pdfMake.fonts = fonts

  console.log("docDefinition",docDefinition)
  
  pdfMake.createPdf(docDefinition).print()
}